import { FormPage } from 'components/formpage';
import styled from 'styled-components';

export const SeriesDetails = styled(FormPage)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
